import api from "../../../services/api";

export const getWholesaleManagerial = async (month: string) => {
  const response = await api.get('/api/wholesale/managerial/managerial_dashboard', {
    params: { month },
  });
  return response.data;
};
